<template>
  <b-modal
    :active="value"
    has-modal-card
    trap-focus
    @close="close"
  >
    <div class="modal-card" style="width: 60vw; max-width: 98vw;">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('upload') }} PackingList</p>
        <button type="button" class="delete" @click="close" />
      </header>
      <section class="modal-card-body">
        <import-entities-optimized
          :can-overwrite="false"
          :project-id="projectId"
          :entity-type="importEntityType"
          :extra-payload="extraPayload"
          @success="onImporterSuccess"
        />
      </section>
    </div>
  </b-modal>
</template>

<script>
import ImportEntitiesOptimized from '../../../components/import-entities-optimized.vue'

export default {
  name: 'warehouse-import-packing-list-modal',
  components: {
    ImportEntitiesOptimized,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: [Number, String],
      required: true,
    },
    importEntityType: {
      type: String,
      default: 'warehouse_packing_list',
    },
    extraPayload: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    onImporterSuccess() {
      this.$emit('success')
      this.$emit('input', false)
    },
  },
}
</script>
